import app from './application-container';
import { Length } from './Units';

/** Default model data, for loading and resizing default models */
export default class DefaultModelData {
    model: string;
    dx: number;
    dy: number;
    dz: number;
    height: number;
    diameter: number;
    units: Length;

    constructor() {
        this.model = '';
        this.dx = 1.0;
        this.dy = 1.0;
        this.dz = 1.0;
        this.height = 1.0;
        this.diameter = 1.0;
        this.units = app.state.display_units || 'cm';
    }
}
